import { KANBAN } from './action';

const initialState = false;

const reducer = (state = initialState, action) => {
    
  switch (action.type) {
    case KANBAN:
        return !state;
    default: {
      return state;
    }
  }
};

export default reducer;
